import React, { useState } from "react";
import { Container } from "react-bootstrap";
import installShot from "./francis_gallery_install.jpg";
import dinnerScene1 from "./dinner_scene_francis.png";
import flyer from "./SummerOpenCall2026_Flyer-Final.jpg";
import preview from "./francis_gallery_preview.png";

const images = [
  { src: installShot, alt: "Francis Gallery Summer Show – installation view" },
  { src: preview, alt: "Francis Gallery Summer Show – preview" },
  { src: flyer, alt: "Francis Gallery Summer Show flyer" },
  { src: dinnerScene1, alt: "Dinner Scene" },
];

function FrancisGallerySummerShow() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? images.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === images.length - 1 ? 0 : c + 1));

  return (
    <Container className="art-section">
      <div className="exhibit-detail-page">
        <div className="exhibit-detail-header">
          <h1 className="exhibit-detail-title">Summer Show</h1>
          <p className="exhibit-detail-venue">
            <a href="https://francisgallery.com/exhibitions/summer-show" target="_blank" rel="noopener noreferrer">
              Francis Gallery
            </a>
          </p>
          <p className="exhibit-detail-info">8323 Melrose Ave., Los Angeles, CA 90069</p>
          <p className="exhibit-detail-info">July 22 – September 12, 2026</p>
        </div>

        <div className="exhibit-carousel">
          <button className="carousel-btn carousel-btn-left" onClick={prev} aria-label="Previous image">&#8249;</button>
          <img src={images[current].src} alt={images[current].alt} className="exhibit-detail-img" />
          <button className="carousel-btn carousel-btn-right" onClick={next} aria-label="Next image">&#8250;</button>
        </div>
        <div className="carousel-dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={`carousel-dot ${i === current ? "active" : ""}`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>

        <a href="https://francisgallery.com/exhibitions/summer-show" target="_blank" rel="noopener noreferrer" className="exhibit-detail-link" style={{ marginBottom: '3rem' }}>
          View Exhibition →
        </a>

        <div className="exhibit-detail-work">
          <h2 className="exhibit-detail-section-title">Featured Work</h2>
          <div className="exhibit-detail-artwork">
            <div className="exhibit-detail-caption">
              <p className="exhibit-detail-artwork-title">Dinner Scene</p>
              <p className="exhibit-detail-artwork-meta">Oil on canvas, 30x40 in., 2025</p>
              <a href="https://francisgallery.com/artworks/dinner-scene" target="_blank" rel="noopener noreferrer" className="exhibit-detail-link">
                View Artwork →
              </a>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default FrancisGallerySummerShow;
